module.exports = __webpack_public_path__ + "img/login.e0e9c67d.png";